export default "__VITE_ASSET__BTx3wwmg__"